import React, { useMemo } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Grid from '@mui/material/Unstable_Grid2';
import { fieldSizing } from '../../utils/utilities';
import FieldInfo from '../FieldInfo/FieldInfo';
import FormHelperText from '@mui/material/FormHelperText';


export default function DatePickerCustom({
    label,
    size,
    name,
    setValue,
    value,
    withInfo,
    description,
    error,
    errorMsg,
    required,
    disabled
}) {
    
    const handleDatechange = (val) => {
        if (setValue) {
            if(val){
                setValue(dayjs(val).format('DD-MMM-YYYY'));
            }else{
                setValue("")
            }
        }
    }

    const fieldSize = useMemo(() =>
        fieldSizing(size)
        , [])

    return (
        <Grid xs={fieldSize.xs} sm={fieldSize.sm} md={fieldSize.md} lg={fieldSize.lg}  >
            <div className="field-container" >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label={required ? label + ' *' : label}
                        name={name}
                        slotProps={{ textField: { fullWidth: true } }}
                        value={value ? dayjs(value) : null}
                        onChange={handleDatechange}
                        // disablePast
                        format="DD-MM-YYYY"
                        disabled={disabled}
                        sx={{ '& .MuiOutlinedInput-notchedOutline' : { borderColor: error && 'error.main'}}}
                    />
                    {withInfo &&
                        <FieldInfo content={description} />
                    }
                </LocalizationProvider>
            </div>
            <FormHelperText error> {error ? errorMsg : ""} </FormHelperText>
        </Grid>
    )
}